import styled, { css } from 'styled-components'
import { fontWeights, colors, breakpoints } from '@/styles'
type ValueType = 'small' | 'default'

type ValueProps = {
  type: ValueType
  hasWarning: boolean
  hasSuccess: boolean
  isLocked?: boolean
  fontWeight?: string
}
const small = css`
  font-weight: ${fontWeights.regular};
  font-size: 14px;
  line-height: 23px;
  color: ${colors.grey16};
`
const defaultValue = css`
  font-weight: ${fontWeights.medium};
  font-size: 16px;
  line-height: 24px;
`

const getTypeStyles = (props: ValueProps) => {
  if (props.type === 'small') return small

  return defaultValue
}

const Label = styled.span<ValueProps>`
  color: ${colors.grey16};
  margin: 0;
  display: inline;
  ${props => getTypeStyles(props)};
  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight}`};
  ${({ hasWarning, hasSuccess }) => {
    if (hasWarning)
      return `
        color: ${colors.red40};
      `
    if (hasSuccess)
      return `
        color: ${colors.green48};
      `
  }}

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    font-size: 14px;
    line-height: 20px;
  }

  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
`

type LabeledProps = {
  type?: ValueType
  hasWarning?: boolean
  hasSuccess?: boolean
  children: string | React.ReactNode
  isLocked: boolean
  fontWeight?: string
}

const LabeledValue: React.FC<LabeledProps> = ({
  type = 'default',
  hasWarning = false,
  hasSuccess = false,
  fontWeight,
  children = '',
  isLocked = false
}) => {
  const randomWords = '*** *****'
  return (
    <Label
      type={type}
      hasWarning={hasWarning}
      hasSuccess={hasSuccess}
      isLocked={isLocked}
      fontWeight={fontWeight}
    >
      {isLocked ? randomWords : children}
    </Label>
  )
}

export default LabeledValue
